module.exports = __webpack_public_path__ + "img/eye.52748277.svg";